export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";